import { render, staticRenderFns } from "./MspGraficoRecord.vue?vue&type=template&id=0a872662"
import script from "./MspGraficoRecord.vue?vue&type=script&lang=js"
export * from "./MspGraficoRecord.vue?vue&type=script&lang=js"
import style0 from "./MspGraficoRecord.vue?vue&type=style&index=0&id=0a872662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports